import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withKeys as _withKeys, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a534754c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "subtitle" }, "账号注册", -1));
const _hoisted_2 = /*#__PURE__*/ _createTextVNode("+86");
const _hoisted_3 = { class: "verify-code" };
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" 选填 ");
const _hoisted_5 = { class: "agreement display-flex align-items" };
const _hoisted_6 = /*#__PURE__*/ _createTextVNode("立即注册");
const _hoisted_7 = { class: "sign-bottom" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "已有账号？", -1));
import PasswordCheck from "@/components/PasswordCheck/index.vue";
import { register } from "@/service/login";
import { checkLoginName, checkPassword, checkPhone, debounce, getMsg, useBcrypt } from "@/utils";
import { defineAsyncComponent, onBeforeUnmount, reactive, ref } from "vue";
import Agreement from "./Agreement.vue";
import { useLogin } from "./hooks";
import { useTiming } from "./hooks/timing";
export default /*#__PURE__*/ _defineComponent({
    name: 'Signup',
    setup(__props) {
        const { changeState } = useLogin();
        const agreement = ref(false);
        const Captcha = defineAsyncComponent(() => import("@/components/CloudCaptcha/index.vue"));
        const accountData = reactive({
            phoneNum: "",
            verifyCode: "",
            name: "",
            company_name: "",
            password: "",
            passwordVerify: "",
            invitation_code: ""
        });
        const password = ref("");
        const passwordVerify = ref("");
        const passwordShow = ref(false);
        const passwordVerifyShow = ref(false);
        const accountForm = ref();
        const isSend = ref(false);
        const stopCountdownCall = () => {
            isSend.value = false;
        };
        const { count, startCountdown, stopCountdown } = useTiming({
            stopCallBack: stopCountdownCall
        });
        const checkSame = (rule, value, callback) => {
            if (value !== accountData.password) {
                callback(new Error("两次输入密码不一致!"));
            }
            else {
                callback();
            }
        };
        //表单验证
        const accountRules = reactive({
            phoneNum: [
                { required: true, message: "请输入手机号~", trigger: "blur" },
                { validator: checkPhone, trigger: "blur" }
            ],
            verifyCode: [{ required: true, message: "请输入验证码~", trigger: "blur" }],
            name: [
                { required: true, message: "请输入用户名~", trigger: "blur" },
                { validator: checkLoginName, trigger: ["blur", "change"] }
            ],
            company_name: [
                { required: true, message: "请输入公司名称~", trigger: "blur" }
            ],
            password: [
                { required: true, message: "请输入密码~", trigger: "blur" },
                { validator: checkPassword, trigger: "blur" }
            ],
            passwordVerify: [
                { required: true, message: "请再次输入密码~", trigger: "blur" },
                { validator: checkSame, trigger: "blur" },
                { validator: checkPassword, trigger: "blur" }
            ]
        });
        //提交表单
        const loginAction = () => {
            accountForm.value.validate((valid) => {
                if (valid) {
                    let params = {
                        name: accountData.name,
                        password: useBcrypt(accountData.password),
                        phone: accountData.phoneNum,
                        code: accountData.verifyCode,
                        company_name: accountData.company_name,
                        invitation_code: accountData.invitation_code
                    };
                    register(params).then(() => {
                        getMsg("注册成功,等待审核", "success");
                        changeState("notify");
                    });
                }
            });
        };
        const captchaRef = ref();
        const validate = () => {
            accountForm.value?.validateField("phoneNum", (valid) => {
                if (valid) {
                    captchaRef.value?.showCaptcha();
                }
            });
        };
        const getCode = debounce(() => {
            isSend.value = true;
            startCountdown();
            getMsg("短信验证码已发送，可能会有延后，请耐心等待", "success");
        }, 500, true);
        onBeforeUnmount(() => {
            stopCountdown();
        });
        const focusHandle = (value) => {
            if (value === "password") {
                passwordShow.value = true;
            }
            else {
                passwordVerifyShow.value = true;
            }
        };
        const blurHandle = (value) => {
            if (value === "password") {
                passwordShow.value = false;
            }
            else {
                passwordVerifyShow.value = false;
            }
        };
        const changeHandle = (value) => {
            if (value === "password") {
                password.value = accountData.password;
            }
            else {
                passwordVerify.value = accountData.passwordVerify;
            }
        };
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_divider = _resolveComponent("el-divider");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            return (_openBlock(), _createElementBlock("div", null, [
                _hoisted_1,
                _createVNode(_component_el_form, {
                    ref_key: "accountForm",
                    ref: accountForm,
                    size: "large",
                    model: accountData,
                    rules: accountRules
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "name" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: accountData.name,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((accountData.name) = $event)),
                                    modelModifiers: { trim: true },
                                    autocomplete: "new-password",
                                    placeholder: "请设置用户名"
                                }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "password" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: accountData.password,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((accountData.password) = $event)),
                                    modelModifiers: { trim: true },
                                    autocomplete: "new-password",
                                    placeholder: "请设置登录密码",
                                    "show-password": "",
                                    onFocus: _cache[2] || (_cache[2] = ($event) => (focusHandle('password'))),
                                    onBlur: _cache[3] || (_cache[3] = ($event) => (blurHandle('password'))),
                                    onInput: _cache[4] || (_cache[4] = ($event) => (changeHandle('password')))
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createVNode(PasswordCheck, { value: password.value }, null, 8, ["value"]), [
                                    [_vShow, passwordShow.value]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "passwordVerify" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: accountData.passwordVerify,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((accountData.passwordVerify) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "再次输入密码",
                                    "show-password": "",
                                    onFocus: _cache[6] || (_cache[6] = ($event) => (focusHandle('passwordVerify'))),
                                    onBlur: _cache[7] || (_cache[7] = ($event) => (blurHandle('passwordVerify'))),
                                    onInput: _cache[8] || (_cache[8] = ($event) => (changeHandle('passwordVerify')))
                                }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "company_name" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: accountData.company_name,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((accountData.company_name) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "请输入公司名称",
                                    maxlength: 100
                                }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                            prop: "phoneNum",
                            class: "phone-item"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: accountData.phoneNum,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((accountData.phoneNum) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "请输入您的手机号"
                                }, {
                                    prepend: _withCtx(() => [
                                        _hoisted_2
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "verifyCode" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_el_input, {
                                        modelValue: accountData.verifyCode,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((accountData.verifyCode) = $event)),
                                        modelModifiers: { trim: true },
                                        placeholder: "请输入您的验证码",
                                        onKeydown: _withKeys(loginAction, ["enter"])
                                    }, null, 8, ["modelValue", "onKeydown"]),
                                    _createVNode(_component_el_button, {
                                        disabled: isSend.value,
                                        onClick: validate
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(isSend.value ? _unref(count) + "秒后重发" : "获取验证码"), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["disabled"])
                                ]),
                                _createVNode(_unref(Captcha), {
                                    ref_key: "captchaRef",
                                    ref: captchaRef,
                                    callback: _unref(getCode),
                                    phone: accountData.phoneNum,
                                    scenario: 1
                                }, null, 8, ["callback", "phone"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "invitation_code" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_divider, null, {
                                    default: _withCtx(() => [
                                        _hoisted_4
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_input, {
                                    modelValue: accountData.invitation_code,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((accountData.invitation_code) = $event)),
                                    modelModifiers: { trim: true },
                                    class: "m-t-20",
                                    placeholder: "请输入邀请码",
                                    maxlength: 100
                                }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["model", "rules"]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_checkbox, {
                        modelValue: agreement.value,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((agreement).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(Agreement, { title: "点击立即注册" })
                ]),
                _createVNode(_component_el_button, {
                    class: "login-btn",
                    size: "large",
                    type: "primary",
                    disabled: !agreement.value,
                    onClick: loginAction
                }, {
                    default: _withCtx(() => [
                        _hoisted_6
                    ]),
                    _: 1
                }, 8, ["disabled"]),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", {
                        class: "aStyle",
                        onClick: _cache[14] || (_cache[14] = ($event) => (_unref(changeState)('login')))
                    }, "立即登录")
                ])
            ]));
        };
    }
});
